import { render, staticRenderFns } from "./EditVirtualMachine.vue?vue&type=template&id=2e0e4a37&scoped=true"
import script from "./EditVirtualMachine.vue?vue&type=script&lang=ts"
export * from "./EditVirtualMachine.vue?vue&type=script&lang=ts"
import style0 from "./EditVirtualMachine.vue?vue&type=style&index=0&id=2e0e4a37&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0e4a37",
  null
  
)

export default component.exports